import { Collapse, Divider, Spin } from "antd";
import {
	ActionButtonComponent,
	EditBannerContainer,
	EditItemsContainer,
} from "./style";
import { BannerItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useBannerContext } from "../../context/BannerContext/BannerContext";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

const EditBanner = () => {
	const { id } = useParams<{ id: string }>();
	const { updateBanner, operationStatus, getBannerDetails } = useBannerContext();

	useEffect(() => {
		if (id) {
			getBannerDetails(id);
		}
	}, [id]);

	return (
		<EditBannerContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<EditItemsContainer>
					<h3>Banner Güncelle</h3>
					<Divider />
					<Collapse
						items={BannerItems}
						expandIconPosition="end"
						bordered={false}
						expandIcon={({ isActive }) => (
							<UpOutlined rotate={isActive ? 0 : -180} />
						)}
						defaultActiveKey={["1", "2", "3"]}
					/>
					<ActionButtonComponent>
						<MainButtonComponent onClick={updateBanner} type="default" loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</ActionButtonComponent>
				</EditItemsContainer>
			</Spin>
		</EditBannerContainer>
	);
};

export default EditBanner;
